export default {"src":"/_next/static/media/0xd7c9f0e536dc865ae858b0c0453fe76d13c3beac.ec69d4ae.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};